/**
 * Agent Report NF 的 `data` 须为非空数组。
 * WebSocketClient 对 NF 使用 broadcast，其它形态（如 wspush userData 的 object `data`）
 * 也会进入各订阅回调，须在 Agent 处理链路上先行排除。
 */
export function isWsAgentReportBatchData(data: unknown): data is unknown[] {
  return Array.isArray(data) && data.length > 0;
}
